// extracted by mini-css-extract-plugin
export var columnList = "_eq-0";